import React from 'react';
import { CheckCircle2Icon, CircleIcon } from 'lucide-react';
import { Objective } from '../types/tombola';
interface ObjectivesListProps {
  objectives: Objective[];
}
export function ObjectivesList({
  objectives
}: ObjectivesListProps) {
  const completedCount = objectives.filter(o => o.completed).length;
  return <div className="space-y-4" data-id="element-65">
      <div className="flex items-center justify-between mb-2" data-id="element-66">
        <span className="text-sm font-medium text-gray-600" data-id="element-67">
          {completedCount}/{objectives.length} complétés
        </span>
      </div>

      <div className="space-y-3" data-id="element-68">
        {objectives.map(objective => <div key={objective.id} className="bg-white rounded-xl p-4 border border-gray-100" data-id="element-69">
            <div className="flex items-start gap-3" data-id="element-70">
              {objective.completed ? <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-71" /> : <CircleIcon className="w-5 h-5 text-gray-300 flex-shrink-0 mt-0.5" data-id="element-72" />}
              <div className="flex-1" data-id="element-73">
                <div className="flex items-center gap-2 mb-1" data-id="element-74">
                  <p className={`text-sm font-medium flex-1 ${objective.completed ? 'text-gray-500 line-through' : 'text-gray-900'}`} data-id="element-75">
                    {objective.title}
                  </p>
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${objective.type === 'daily' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`} data-id="element-76">
                    {objective.type === 'daily' ? 'Quotidien' : 'Hebdomadaire'}
                  </span>
                </div>
                {!objective.completed && <div className="mt-2" data-id="element-77">
                    <div className="flex justify-between text-xs text-gray-500 mb-1" data-id="element-78">
                      <span data-id="element-79">
                        {objective.current}/{objective.target}
                      </span>
                      <span data-id="element-80">
                        {Math.round(objective.current / objective.target * 100)}
                        %
                      </span>
                    </div>
                    <div className="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-81">
                      <div className={`h-full rounded-full transition-all duration-300 ${objective.type === 'daily' ? 'bg-gradient-to-r from-blue-500 to-blue-600' : 'bg-gradient-to-r from-purple-500 to-purple-600'}`} style={{
                  width: `${objective.current / objective.target * 100}%`
                }} data-id="element-82" />
                    </div>
                  </div>}
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}